import {ErrorHandler, inject, NgModule, provideAppInitializer} from '@angular/core';
import * as Sentry from '@sentry/angular';
import {TraceService} from '@sentry/angular';
import {MaterialModule} from './shared/material/material.module';
import {AppRoutingModule} from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {StoreModule} from '@ngrx/store';
import {LiveMapModule} from './pages/live-map/live-map.module';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {liveMapReducer} from './pages/live-map/store/live-map.reducer';
import {Router, RouteReuseStrategy} from '@angular/router';
import {CustomRouteReuseStrategy} from './router-strategy';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AmplifyAuthenticatorModule} from '@aws-amplify/ui-angular';
import {AuthInterceptor} from './security/auth.interceptor';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {Amplify} from 'aws-amplify';
import {environment} from '../environments/environment';
import { MarkdownModule } from 'ngx-markdown';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: environment.authentication.clientId,
      userPoolId: environment.authentication.userPoolId,
      userPoolEndpoint: !!environment.authentication.endpoint ? environment.authentication.endpoint : undefined,
      signUpVerificationMethod: 'code',
      mfa: {
        status: 'optional',
      },
    }
  }
});

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    LiveMapModule,
    StoreModule.forRoot({ ui: liveMapReducer }),
    AmplifyAuthenticatorModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    {
      provide: 'googleTagManagerId',
      useValue: 'GTM-TJZF5SCB',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
